import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var write_t = Atdgen_codec_runtime.Encode.make(function (x) {
  if (typeof x === "number") {
    if (x >= 357830602) {
      if (x !== 492530731) {
        if (x >= 891112544) {
          if (x >= 994393768) {
            return Atdgen_codec_runtime.Encode.constr0("PATCH");
          } else {
            return Atdgen_codec_runtime.Encode.constr0("POST");
          }
        } else if (x >= 801894688) {
          return Atdgen_codec_runtime.Encode.constr0("HEAD");
        } else {
          return Atdgen_codec_runtime.Encode.constr0("CONNECT");
        }
      } else {
        return Atdgen_codec_runtime.Encode.constr0("DELETE");
      }
    } else if (x >= 3997359) {
      if (x >= 336447077) {
        return Atdgen_codec_runtime.Encode.constr0("TRACE");
      } else {
        return Atdgen_codec_runtime.Encode.constr0("PUT");
      }
    } else if (x >= 3546230) {
      return Atdgen_codec_runtime.Encode.constr0("GET");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("OPTIONS");
    }
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Other", Atdgen_codec_runtime.Encode.string, x[1]);
  }
});
var read_t = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["GET",
/* `Single */
[-306849112,
/* GET */
3546230]],
/* :: */
[
/* tuple */
["POST",
/* `Single */
[-306849112,
/* POST */
891112544]],
/* :: */
[
/* tuple */
["HEAD",
/* `Single */
[-306849112,
/* HEAD */
801894688]],
/* :: */
[
/* tuple */
["DELETE",
/* `Single */
[-306849112,
/* DELETE */
492530731]],
/* :: */
[
/* tuple */
["PATCH",
/* `Single */
[-306849112,
/* PATCH */
994393768]],
/* :: */
[
/* tuple */
["PUT",
/* `Single */
[-306849112,
/* PUT */
3997359]],
/* :: */
[
/* tuple */
["OPTIONS",
/* `Single */
[-306849112,
/* OPTIONS */
-539883714]],
/* :: */
[
/* tuple */
["TRACE",
/* `Single */
[-306849112,
/* TRACE */
336447077]],
/* :: */
[
/* tuple */
["CONNECT",
/* `Single */
[-306849112,
/* CONNECT */
357830602]],
/* :: */
[
/* tuple */
["Other",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Other */
      [-912009552, x]
    );
  }, Atdgen_codec_runtime.Decode.string, param);
}]],
/* [] */
0]]]]]]]]]]);
export { read_t, write_t };
/* write_t Not a pure module */